import axios from 'axios';

const GOOGLE_MAPS_API_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
const GOOGLE_MAPS_API_TOKEN = window.options.GOOGLE_MAPS_API_TOKEN;

const RegionService = {
  buildRegion: response => {
    if (!response.status || response.status !== 'OK') return;

    const political = response.results.find(item =>
      item.types.includes('political')
    );
    if (!political) return;

    const administrative_area = political.address_components.find(
      item => item.types && item.types.includes('administrative_area_level_1')
    );
    if (!administrative_area) return;

    return administrative_area.short_name;
  },
  fetchRegionByCoordinates: ({ latitude, longitude, onComplete }) => {
    axios
      .request({
        url: GOOGLE_MAPS_API_URL,
        method: 'GET',
        params: {
          latlng: `${latitude},${longitude}`,
          key: GOOGLE_MAPS_API_TOKEN,
        },
      })
      .then(response => {
        const regionUF = RegionService.buildRegion(response.data);
        onComplete(regionUF);
      })
      .catch(error => console.error(error));
  },
};

export default RegionService;
